// shouldSkipSSRFetch.js
'use strict';

import env from '../resource/env.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import { SKIP_SSR_FETCH_QUERIES } from '../RemoteConfigKeys.js';

/**
 * Should skip SSR fetch
 * @param {URL} requestUrl - request URL object.
 * @param {object} [state] - redux state, used to read remoteConfig.
 * @return {boolean} Return true if SSR fetch should be skipped.
 */
const shouldSkipSSRFetch = ({ requestUrl, state }) => {
  const remoteConfigValue = state
    ? getRemoteConfigData(state, SKIP_SSR_FETCH_QUERIES)
    : '';
  const skipQueries = (remoteConfigValue || env.SKIP_SSR_FETCH_QUERIES || '')
    .split(' ')
    .filter(Boolean);
  return skipQueries.some(q => requestUrl.searchParams.has(q));
};

export default shouldSkipSSRFetch;
